/* unplugin-vue-components disabled */import { render } from "./ManagePeriodicReviewers.vue?vue&type=template&id=3b722eba&scoped=true&ts=true"
import script from "./ManagePeriodicReviewers.vue?vue&type=script&lang=ts"
export * from "./ManagePeriodicReviewers.vue?vue&type=script&lang=ts"

import "./ManagePeriodicReviewers.vue?vue&type=style&index=0&id=3b722eba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b722eba"]])

export default __exports__